import { BrowserRouter } from 'react-router-dom'
import { Flip, ToastContainer } from 'react-toastify'

import { useAppSelector } from '../store/hooks'
import AppRoute from './AppRoute'
import AuthRouter from './AuthRouter'

export const MainRouter = () => {
  const { key } = useAppSelector((state) => state.session)

  return (
    <BrowserRouter>
      <ToastContainer
        draggable={true}
        hideProgressBar
        newestOnTop={true}
        pauseOnHover
        position="top-center"
        rtl={false}
        theme="light"
        transition={Flip}
      />
      {key ? <AppRoute /> : <AuthRouter />}
    </BrowserRouter>
  )
}
